// Lightweight replacement for cocoon.
//
// Markup contract:
//   <div data-nested-form>
//     <div data-nested-form-list>
//       <div data-nested-form-item>
//         ...fields...
//         <button type="button" data-nested-form-remove>Quitar</button>
//       </div>
//     </div>
//     <template data-nested-form-template>
//       <div data-nested-form-item>
//         ...fields with __INDEX__ placeholders in names/ids...
//       </div>
//     </template>
//     <button type="button" data-nested-form-add>+ Agregar</button>
//   </div>
//
// On add: clone the template, replace __INDEX__ with a unique key, append,
//   then fire `combobox:init` so nested comboboxes wire themselves up.
// On remove: if the item has a hidden _destroy field (persisted record),
//   set it to "1" and hide the row; otherwise drop the node from the DOM.

const ROOT_SELECTOR = "[data-nested-form]"

function init(root) {
  if (root.dataset.nestedFormInit === "1") return
  root.dataset.nestedFormInit = "1"

  const list = root.querySelector("[data-nested-form-list]")
  const template = root.querySelector("[data-nested-form-template]")
  const addBtn = root.querySelector("[data-nested-form-add]")
  if (!list || !template || !addBtn) return

  addBtn.addEventListener("click", (event) => {
    event.preventDefault()
    // Rails strong_parameters only accepts numeric keys when mixed with the
    // server-rendered "0", "1", … keys. Use a timestamp-based integer.
    const key = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    const html = template.innerHTML.replace(/__INDEX__/g, key)
    const wrapper = document.createElement("div")
    wrapper.innerHTML = html.trim()
    const item = wrapper.firstElementChild
    if (!item) return
    list.appendChild(item)
    item.dispatchEvent(new CustomEvent("nested-form:added", { bubbles: true, detail: { item } }))
    document.dispatchEvent(new CustomEvent("combobox:init", { detail: { scope: item } }))
  })

  list.addEventListener("click", (event) => {
    const removeBtn = event.target.closest("[data-nested-form-remove]")
    if (!removeBtn || !list.contains(removeBtn)) return
    event.preventDefault()
    const item = removeBtn.closest("[data-nested-form-item]")
    if (!item) return

    const destroyInput = item.querySelector("input[name$='[_destroy]']")
    if (destroyInput) {
      destroyInput.value = "1"
      item.hidden = true
    } else {
      item.remove()
    }
    item.dispatchEvent(new CustomEvent("nested-form:removed", { bubbles: true, detail: { item } }))
  })
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(ROOT_SELECTOR).forEach(init)
})
